var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1668 21.3327L20.8485 16.9994L16.1668 12.6677V21.3327ZM23.6335 18.9646L17.5635 24.5812C17.0318 25.0746 16.3402 25.3329 15.6352 25.3329C15.2468 25.3329 14.8518 25.2529 14.4802 25.0912C13.4635 24.6479 12.8335 23.6996 12.8335 22.6162V11.3829C12.8335 10.3012 13.4635 9.35122 14.4802 8.90955C15.5235 8.45122 16.7352 8.65122 17.5652 9.41955L23.6335 15.0362C24.1852 15.5446 24.5002 16.2612 24.5002 16.9996C24.5002 17.7396 24.1852 18.4546 23.6335 18.9646ZM17.0002 0.332886C7.81016 0.332886 0.333496 7.81122 0.333496 16.9996C0.333496 26.1896 7.81016 33.6662 17.0002 33.6662C26.1902 33.6662 33.6668 26.1896 33.6668 16.9996C33.6668 7.81122 26.1902 0.332886 17.0002 0.332886Z",
    fill: "#183263"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.933386e729f1030f95b38523610d9f8f.svg";
export { ForwardRef as ReactComponent };